import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  fallbackAlert: {
    defaultMessage:
      'The selected combination is not available. Showing closest match.',
  },
});
